// extracted by mini-css-extract-plugin
export var quillEditor = "_pe-1";
export var variable = "_pe-0";